import { useMemo } from 'react'
import _filter from 'lodash/filter'
import isEmpty from 'lodash/isEmpty'
import type { DataToolField } from '../constants/DataToolField'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'

export const useDataToolFields = (
  fields: DataToolField[]
): {
  sortFields: DataToolField[]
  filterFields: DataToolField[]
  searchFields: DataToolField[]
} => {
  return useMemo(() => {
    //get
    let sortFields = _filter(fields, (m) => !m.excludeOnSort)
    let searchFields = _filter(fields, (m) => !m.excludeOnSearch && m.type !== ListFieldTypeEnum.number) //number types are not searchable so exclude it also
    let filterFields = _filter(fields, (m) => !m.excludeOnFilter)

    sortFields = !isEmpty(sortFields) ? sortFields : [{ name: 'code' }, { name: 'remarks' }]
    searchFields = !isEmpty(searchFields) ? searchFields : [{ name: 'remarks' }, { name: 'code' }, { name: 'tags' }]
    filterFields = !isEmpty(filterFields) ? filterFields : [{ name: 'remarks' }, { name: 'code' }, { name: 'tags' }]

    return { sortFields, filterFields, searchFields }
  }, [fields])
}
